import React from "react";
import Sidebar from "./sidebar";
import Topbar from "./topbar";
import { useSidebar } from "../Contexts/sidebar";

const Layout = (props) => {
  const { isCollapsed, isDarkMode } = useSidebar();

  return (
    <main className={`${isCollapsed ? 'flex flex-col md:flex-row' : 'flex'} flex-auto w-full max-w-full relative overflow-x-hidden ${isDarkMode ? 'bg-gray-900' : 'bg-white'}`}>
      <Sidebar />
      <div className={`wrapper ${isCollapsed ? 'w-full' : 'w-11/12'} min-w-0 flex flex-col transition-all duration-300`}>
        <Topbar className="flex-grow-0" />
        <div className={`content w-full min-w-0 max-w-full flex-grow overflow-x-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-catskill'}`}>
          {props.children}
        </div>
      </div>
    </main>
  );
};

export default Layout;
